import {createElement, Component, PropTypes} from 'rlink-react';
import ReactDOM from 'react-dom';
import ConnectedMountRootComponent from 'rlink-router/ConnectedMountRootComponent.jsx';

export default function _mountRoot (buildContext, mountRootId) {
  if (typeof document !== 'undefined') {
    ReactDOM.render(<ConnectedMountRootComponent
      buildContext={buildContext}
      store={buildContext.reduxStore} />,
      document.getElementById(mountRootId));
  }
  return {type: 'NOOP'};
}




// WEBPACK FOOTER //
// ./lib/rlink-router/actions/_mountRoot.jsx